module.exports = require("./bg.d.ts");